import { FlowsheetContext } from "@/components/FlowSheetEditor/FlowsheetProvider"
import { Node } from "@antv/x6"
import Title from "antd/lib/typography/Title"
import classNames from "classnames"
import { useContext, useEffect, useState } from "react"
import { UnitLayout } from "./UnitLayout"
import { BasicRichTextEditor } from "@/components/BasicRichTextEditor/BasicRichTextEditor"
import { useReloadWhenUnitChange } from "./useReloadWhenUnitChange"
import { RollBackButton } from "./RollBackButton"

interface TextNodePanelProps {
  unit: Node
}
export const TextNodePanel = (props: TextNodePanelProps) => {
  const {unit} = props
  const [node, setNode] = useState(unit)
  const data = node.getData()
  const text = data.text;
  const [override, setOverride] = useState(data.override || false)
  const [content, setContent] = useState(text)
  const {changeCellProps, isTemplate} = useContext(FlowsheetContext)
  useReloadWhenUnitChange(node)

  useEffect(() => {
    setNode(unit)
  }, [unit])

  useEffect(() => {
    setContent(text)
  }, [text])

  const onChange = (val) => {
    setContent(val)
    const changes = {text: val} as any
    if (!isTemplate) {
      changes.override = true
    }
    changeCellProps(node.id, changes)
    if (changes.override) {
      setOverride(true)
    }
  }

  const onLayoutChange = () => {
    if (!isTemplate) {
      const changes = {override: true}
      changeCellProps(unit.id, changes)
      setOverride(true)
    }
  }

  const handleOverrideChange = () => {
    setOverride(false)
  }

  return <div className="unit-container">
    <div className={classNames('unit-header', 'flex-space-btw')}>
      <div>Text Options</div>
      <RollBackButton override={override} node={node} onOverrideChange={handleOverrideChange} />
    </div>
    <div className="p-1">
      <UnitLayout unit={node} onChange={onLayoutChange} />
      <Title level={5} className="mt-1">Text Content</Title>
      {/* <Space className="mt-1">
        <span>Content:</span>
        <Input value={content} onChange={onChange} />
      </Space> */}
      <div>
        <div>Content</div>
        <div className="ql-container">
          <BasicRichTextEditor defaultValue={content} onChange={onChange} />
        </div>
      </div>
    </div>
  </div>
}